module.exports = fox._r("fonts/PTSans-Regular.ttf", __webpack_public_path__ + "_/_/_/root/fonts/3HrsILf.ttf");


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/site/root/fonts/PTSans-Regular.ttf
// module id = 195
// module chunks = 4